/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_Edit_TitleInputs */

const en_carrier_notices_edit_title = /** @type {(inputs: Carrier_Notices_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit carrier notice`)
};

const es_carrier_notices_edit_title = /** @type {(inputs: Carrier_Notices_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar aviso de transportista`)
};

/**
* | output |
* | --- |
* | "Edit carrier notice" |
*
* @param {Carrier_Notices_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_edit_title = /** @type {((inputs?: Carrier_Notices_Edit_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Edit_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_edit_title(inputs)
	return es_carrier_notices_edit_title(inputs)
});